const getters = {
    breadCrumbList: state => JSON.parse(state.app.breadCrumbList),
    allRouter: state => JSON.parse(state.app.allRouter),
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    category: state => state.user.category
}

export default getters;